import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Result } from 'antd';
import { IMAGE_SIZE } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import { ResultSubTitle, ResultTitle } from '../style';

type Props = {
  size?: number;
  className?: string;
};

export const EmptyResults: FC<Props> = ({ size, className = '' }) => {
  const { t } = useTranslation();

  return (
    <Result
      className={className}
      style={{ paddingTop: '20px' }}
      title={<ResultTitle>{t('emptyMessages.noResultsTitle')}</ResultTitle>}
      icon={
        <GlobalIcon
          lib="generic"
          name="noMatches"
          theme="colored"
          size={size ?? IMAGE_SIZE._176}
          skeleton={{ useEmptyPlaceholder: true }}
        />
      }
      subTitle={
        <ResultSubTitle>
          {t('emptyMessages.noResultsDescription')}
        </ResultSubTitle>
      }
    />
  );
};
